import { render, staticRenderFns } from "./cm-taxas.vue?vue&type=template&id=58cc4980&scoped=true&"
import script from "./cm-taxas.vue?vue&type=script&lang=js&"
export * from "./cm-taxas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cc4980",
  null
  
)

export default component.exports